/* Cinematic PDP — See It To Scale Visualizer
   Adapted from insigne-pro visualizer
   Reads window.__vizData (set in Liquid) */
(function(){
  var SD, cur = 0;
  var room, artEl, artImg, sofaEl, sofaSvg, mh, mhL, mhR, mhB, mv, mvT, mvBt, mvB;
  var shSofa, shPlant, shLamp, shadowsReady = false;

  function init(){
    SD = window.__vizData;
    if(!SD || !SD.length) return;
    room = document.getElementById('vizRoom');
    if(!room) return;
    artEl = document.getElementById('vizArt');
    artImg = document.getElementById('vizArtImg');
    sofaEl = document.getElementById('vizSofa');
    sofaSvg = document.getElementById('vizSofaSvg');
    mh = document.getElementById('vizMh');
    mhL = document.getElementById('vizMhL');
    mhR = document.getElementById('vizMhR');
    mhB = document.getElementById('vizMhB');
    mv = document.getElementById('vizMv');
    mvT = document.getElementById('vizMvT');
    mvBt = document.getElementById('vizMvBt');
    mvB = document.getElementById('vizMvB');

    /* Size tabs */
    document.querySelectorAll('.viz-tab').forEach(function(tab, i){
      tab.addEventListener('click', function(){ pickSize(i); });
    });

    /* Day/night toggle */
    var toggle = document.getElementById('vizThemeToggle');
    if(toggle) toggle.addEventListener('click', function(){
      room.classList.toggle('viz-dark');
      var isDark = room.classList.contains('viz-dark');
      toggle.setAttribute('aria-label', isDark ? 'Switch to day mode' : 'Switch to night mode');
      var ico = toggle.querySelector('svg');
      if(ico){
        ico.innerHTML = isDark
          ? '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z" fill="none" stroke="currentColor" stroke-width="1.5"/>'
          : '<circle cx="12" cy="12" r="5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>';
      }
      layout(); /* re-render shadows with new dark/light alpha */
    });

    /* Create silhouette shadow — clone the actual furniture image */
    function mkSh(imgSrc){
      var d = document.createElement('div'); d.className = 'viz-shadow';
      var img = document.createElement('img');
      img.src = imgSrc; img.draggable = false; img.setAttribute('aria-hidden','true');
      d.appendChild(img); room.appendChild(d); return d;
    }
    var sofaSrc = sofaSvg ? sofaSvg.src : '';
    var plantImg = document.querySelector('#vizPlant img');
    var lampImg = document.querySelector('#vizLamp img');
    if(sofaSrc) shSofa = mkSh(sofaSrc);
    if(plantImg){ shPlant = mkSh(plantImg.src); shPlant.classList.add('viz-shadow--plant'); }
    if(lampImg){ shLamp = mkSh(lampImg.src); shLamp.classList.add('viz-shadow--lamp'); }
    shadowsReady = true;

    /* Wait for image to get natural dimensions */
    if(artImg && artImg.complete) layout();
    else if(artImg) artImg.onload = layout;
    else layout();

    /* Show section */
    var sec = document.getElementById('vizSec');
    if(sec) sec.style.display = '';
  }

  function pickSize(i){
    if(!SD || !SD[i]) return;
    cur = i;
    document.querySelectorAll('.viz-tab').forEach(function(t, j){ t.classList.toggle('on', j === i); });
    layout();
    /* Update vdata — after layout so _dW/_dH are set from PNG ratio */
    var s = SD[i];
    var vdW = document.getElementById('vizVdW');
    var vdWt = document.getElementById('vizVdWt');
    var vdP = document.getElementById('vizVdP');
    if(vdW) vdW.textContent = (s._dW || s.iW) + '" x ' + (s._dH || s.iH) + '"';
    if(vdWt) vdWt.textContent = s.wt;
    if(vdP) vdP.textContent = '$' + s.p;
  }
  window.pickVizSize = pickSize;

  function layout(){
    if(!room || !SD || !SD[cur]) return;
    var W = room.clientWidth, H = room.clientHeight;
    if(!W || !H){ setTimeout(layout, 200); return; }
    var s = SD[cur];
    if(!s.iW || !s.iH){ s.iW = s.iW || 28.5; s.iH = s.iH || 18; }

    var n1 = s.iW, n2 = s.iH;
    var pc = s.pc || 1;
    var big = Math.max(n1, n2), small = Math.min(n1, n2);

    /* PNG determines visual orientation — variant order is irrelevant */
    var natR = 1;
    if(artImg && artImg.naturalWidth && artImg.naturalHeight){
      natR = artImg.naturalWidth / artImg.naturalHeight;
    }

    var totalW, totalH;
    if(pc <= 1){
      /* Single piece: landscape PNG → width=big, portrait PNG → width=small */
      if(natR >= 1){ totalW = big; totalH = small; }
      else { totalW = small; totalH = big; }
    } else {
      /* Multi-piece: try both arrangements, pick the one matching PNG ratio.
         A = portrait pieces side by side: each piece small×big
         B = landscape pieces side by side: each piece big×small */
      var gapIn = 2;
      var rA = (small * pc + gapIn * (pc - 1)) / big;
      var rB = (big * pc + gapIn * (pc - 1)) / small;
      if(Math.abs(natR - rA) <= Math.abs(natR - rB)){
        totalW = small * pc + gapIn * (pc - 1); totalH = big;
      } else {
        totalW = big * pc + gapIn * (pc - 1); totalH = small;
      }
    }
    s._dW = totalW; s._dH = totalH;

    var isMobile = W < 600;
    var lblH = 22, ceil = lblH + 16;
    var baseY = H * 0.92, gap = H * 0.035;
    var sfW = isMobile ? W * 0.78 : W * 0.52;
    var sofaVisW = sfW * (364/420);
    var ppi = sofaVisW / 84;
    var sfH = 28 * ppi * (100/72);

    /* Pixel size from real-inch dimensions, constrained to PNG ratio */
    var aW = totalW * ppi, aH = totalH * ppi;
    var aW2 = aH * natR, aH2 = aW / natR;
    if(aW2 <= aW){ aW = aW2; } else { aH = aH2; }

    var availH = baseY - ceil;
    var neededH = aH + gap + sfH;
    if(neededH > availH){ var sc = availH/neededH; sfW*=sc; sfH*=sc; aW*=sc; aH*=sc; gap*=sc; }
    if(aW > W * 0.92){ var wSc = (W*0.92)/aW; aW*=wSc; aH*=wSc; sfW*=wSc; sfH*=wSc; gap*=wSc; }

    var sfTop = baseY - sfH, sfLeft = (W - sfW) / 2;
    sofaSvg.style.width = sfW + 'px';
    sofaSvg.style.height = sfH + 'px';
    sofaSvg.style.transition = 'width 0.4s ease, height 0.4s ease';
    sofaEl.style.left = sfLeft + 'px';
    sofaEl.style.top = sfTop + 'px';
    sofaEl.style.transition = 'left 0.4s ease, top 0.4s ease';

    var aBottom = sfTop - gap, aTop = aBottom - aH;
    var aLeft = (W - aW) / 2;
    artEl.style.width = aW + 'px';
    artEl.style.height = aH + 'px';
    artEl.style.left = aLeft + 'px';
    artEl.style.top = aTop + 'px';

    /* Artwork shadow is set at the end of layout() */

    /* Horizontal measurement */
    var cx = aLeft + aW/2;
    mh.style.top = (aTop - lblH - 12) + 'px';
    mh.style.left = cx + 'px';
    mh.style.transform = 'translateX(-50%)';
    mhL.style.width = (aW/2) + 'px';
    mhR.style.width = (aW/2) + 'px';
    mhB.textContent = totalW + '"';

    /* Vertical measurement */
    mv.style.left = (aLeft + aW + 4) + 'px';
    mv.style.top = (aTop + aH/2) + 'px';
    mv.style.transform = 'translateY(-50%)';
    mvT.style.height = (aH/2) + 'px';
    mvBt.style.height = (aH/2) + 'px';
    mvB.textContent = totalH + '"';

    /* Sofa measurement ruler — aligned to outer edges of sofa */
    var sfRuler = room.querySelector('.viz-sofa-ruler');
    if(!sfRuler){
      sfRuler = document.createElement('div');
      sfRuler.className = 'viz-sofa-ruler';
      sfRuler.innerHTML = '<div class="viz-sofa-ruler__cap"></div><div class="viz-sofa-ruler__line"></div><div class="viz-sofa-ruler__label">84"</div><div class="viz-sofa-ruler__line"></div><div class="viz-sofa-ruler__cap"></div>';
      room.appendChild(sfRuler);
    }
    sfRuler.style.position = 'absolute';
    sfRuler.style.left = sfLeft + 'px';
    sfRuler.style.width = sfW + 'px';
    sfRuler.style.top = (baseY + 8) + 'px';
    /* Hide old label */
    var sfL = room.querySelector('.viz-sofa-lbl');
    if(sfL) sfL.style.display = 'none';

    /* Plant & lamp scale proportionally to sofa height */

    /* baseY = where furniture feet touch the ground (H * 0.86) */

    /* Plant: ratio 0.794, bottom aligned with sofa bottom (baseY) */
    var plant = document.getElementById('vizPlant');
    if(plant){
      var plantH = sfH * 1.05;
      var plantW = plantH * 0.794;
      var plantTop = baseY - plantH;
      var plantLeft = sfLeft - plantW - 10;
      if(plantLeft < 2) plantLeft = 2;
      plant.style.position = 'absolute';
      plant.style.top = plantTop + 'px';
      plant.style.left = plantLeft + 'px';
      plant.style.width = plantW + 'px';
      plant.style.height = plantH + 'px';
      plant.style.transition = 'all 0.4s ease';
    }

    /* Floor lamp: ratio 0.387, bottom aligned with sofa bottom */
    var lamp = document.getElementById('vizLamp');
    if(lamp){
      var lampH = sfH * 1.4;
      var lampW = lampH * 0.387;
      var lampTop = baseY - lampH;
      var lampLeft = sfLeft + sfW + 10;
      if(lampLeft + lampW > W - 2) lampLeft = W - lampW - 2;
      lamp.style.position = 'absolute';
      lamp.style.top = lampTop + 'px';
      lamp.style.left = lampLeft + 'px';
      lamp.style.width = lampW + 'px';
      lamp.style.height = lampH + 'px';
      lamp.style.transition = 'all 0.4s ease';
    }

    /* ── Silhouette cast shadows — anchored at furniture base, skew from bottom ── */
    if(!shadowsReady) return;
    var isDark = room.classList.contains('viz-dark');
    var opa = isDark ? 0.28 : 0.15;

    function castSh(el, oL, oT, oW, oH, extraBlur){
      if(!el) return;
      el.style.left = oL + 'px';
      el.style.top = oT + 'px';
      el.style.width = oW + 'px';
      el.style.height = oH + 'px';
      el.style.opacity = opa;
      el.style.transform = 'skewX(-12deg)';
      if(extraBlur) el.querySelector('img').style.filter = 'brightness(0) blur(' + extraBlur + 'px)';
    }

    castSh(shSofa, sfLeft, sfTop, sfW, sfH);
    if(plant) castSh(shPlant, plantLeft, plantTop, plantW, plantH);
    if(lamp) castSh(shLamp, lampLeft, lampTop, lampW, lampH, 6);

    /* Artwork shadow — single sharp drop-shadow, down-right */
    var artAlpha = isDark ? 0.5 : 0.3;
    artEl.style.filter = 'drop-shadow(5px 6px 4px rgba(0,0,0,' + artAlpha + '))';
    artEl.style.boxShadow = 'none';
  }

  var _rt; window.addEventListener('resize', function(){ clearTimeout(_rt); _rt = setTimeout(layout, 150); }, {passive:true});

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ setTimeout(init, 300); });
  else setTimeout(init, 300);
})();
